
console.log(" _______   ______   ______   __    __  __    __   ______\r\n/       \\ /      | /      \\ /  \\  /  |/  |  /  | /      \\ \r\n$$$$$$$  |$$$$$$/ /$$$$$$  |$$  \\ $$ |$$ |  $$ |/$$$$$$  |\r\n$$ |__$$ |  $$ |  $$ | _$$/ $$$  \\$$ |$$ |  $$ |$$ \\__$$/\r\n$$    $$/   $$ |  $$ |/    |$$$$  $$ |$$ |  $$ |$$      \\ \r\n$$$$$$$/    $$ |  $$ |$$$$ |$$ $$ $$ |$$ |  $$ | $$$$$$  |\r\n$$ |       _$$ |_ $$ \\__$$ |$$ |$$$$ |$$ \\__$$ |/  \\__$$ |\r\n$$ |      / $$   |$$    $$/ $$ | $$$ |$$    $$/ $$    $$/\r\n$$/       $$$$$$/  $$$$$$/  $$/   $$/  $$$$$$/   $$$$$$/\r\n");
console.log("( '-')b", "Copyright ©2022 Pignus. All rights reserved.");

import { d, i, e, setDebug } from './core/log.js';
import * as design from './core/design.js';


function Tacklebox() {
    this.ver = "1.0";
}

export default {
    d, i, e, setDebug,
    Tacklebox,
    design,
};
